import React from 'react';

import ButtonLink, { IButtonLink } from 'components/primitives/ButtonLink';

import Reveal from '../../blocks/Reveal';

export interface ICardImage {
  image?: string;
  title: string;
  copy: string;
  button?: IButtonLink;
  orchidTheme?: boolean;
}

const CardImage = ({ image, title, copy, button, orchidTheme }: ICardImage) => {
  const bgImageStyle = {
    paddingTop: '56.25%', // aspect ratio 16:9
    backgroundImage: `url(${image})`,
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className='bg-white shadow-md hover:shadow-card-hover flex flex-col h-full cursor-pointer transition-all ease-in-out duration-300'
      onClick={() => {
        if (button && button.target && button.target === '_blank') {
          window.open(button.url, button.target);
        } else {
          window.location.href = button ? button.url : '';
        }
      }}
    >
      {image && (
        <div
          className='bg-center bg-no-repeat bg-cover flex-2'
          style={bgImageStyle}
        />
      )}
      <div className='flex-1 px-10 pt-7 pb-9 flex-3'>
        <Reveal>
          <h3
            className={`text-center ${!orchidTheme ? 'text-orchid' : 'text-'}`}
          >
            {title}
          </h3>
        </Reveal>
        <Reveal>
          <div
            className='cardImageDescription font-light mt-4'
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        </Reveal>
      </div>
      <div className='flex-1 flex items-end'>
        {button && <ButtonLink {...button} />}
      </div>
    </div>
  );
};

CardImage.defaultProps = {
  image: undefined,
  button: undefined,
  orchidTheme: false,
};

export default CardImage;
